/** Audit F-056 (change #6): the onboarding model (about 57 kB, about 2 s to build) was fetched again every time the
 * onboarding frame mounted and every time the window regained focus. A model fetched in the last 30 seconds is reused,
 * and any successful save anywhere (api.ts dispatches 'canonical-record-saved') discards it. */
export const onboardingModelFreshMs=30_000;
const cache=new Map<string,{model:unknown;at:number}>();

export function freshOnboardingModel<T>(building:string,now=Date.now()):T|undefined{
 const entry=cache.get(building);
 return entry&&now-entry.at<onboardingModelFreshMs?entry.model as T:undefined;
}
export function rememberOnboardingModel(building:string,model:unknown,now=Date.now()){cache.set(building,{model,at:now});}
export function forgetOnboardingModels(){cache.clear();}
if(typeof window!=='undefined')window.addEventListener('canonical-record-saved',forgetOnboardingModels);
